import angular from 'angular';

(function () {
    'use strict';

    // Component DEF
    var kissModifyButton = {
        templateUrl: require('./modify-button.html'),
        bindings: {
            actionValidate: '&',
            actionCancel: '&',
            actionDelete: '&',
            showDeleteButton: '<',
            deletable: '<',
            isDisabled: '<',
            hideBackDo: '<',
        },
    };

    // Add to the App
    angular.module('app.principal').component('kissModifyButton', kissModifyButton);
})();
